import { createConsumer } from "@rails/actioncable"
import type { Consumer } from "rails__actioncable"

import { cableConfig } from "./config"

// Singleton consumer with SSR guard
let singletonConsumer: Consumer | null = null

export function getConsumer(): Consumer | null {
  if (typeof window === "undefined") return null
  if (singletonConsumer) return singletonConsumer
  if (!cableConfig) {
    console.warn("Cable not configured. Call configureCable() first.")
    return null
  }
  singletonConsumer = createConsumer(cableConfig.url)
  return singletonConsumer
}

export function teardownCable(): void {
  if (singletonConsumer) {
    singletonConsumer.disconnect()
    singletonConsumer = null
  }
}

// if (typeof window !== "undefined") {
//   window.addEventListener("beforeunload", () => {
//     teardownCable()
//   })
// }
